import { Button, DialogActions, palettes } from '@indigo-ag/component-module';
import i18next from 'core/i18n';
import React, { useState } from 'react';
import { createStylesHook } from 'shared/hooks/createStylesHook';

interface ModalActionButtonProps {
  closeModal: () => void;
  changeButtonName: string;
  disabled?: boolean;
  save: () => Promise<unknown>;
  destructive?: boolean;
}

const useStyles = createStylesHook({
  MuiDialogActionsRoot: {
    background: palettes.neutral.white,
    justifyContent: 'flex-end',
    margin: 0,
    padding: 32
  }
});

export const ModalActionButtons: React.FunctionComponent<ModalActionButtonProps> = ({
  closeModal,
  changeButtonName,
  disabled = false,
  save,
  destructive
}) => {
  /**
   * State
   */
  const [isSaving, setIsSaving] = useState(false);

  /**
   * Styles
   */
  const classes = useStyles();

  const close = () => closeModal();

  const saveChanges = async () => {
    setIsSaving(true);
    try {
      await save();
      close();
    } catch {
      setIsSaving(false);
    }
  };
  return (
    <DialogActions classes={{ root: classes.MuiDialogActionsRoot }}>
      <Button onClick={close} type="button" size="small" variant="secondary">
        {i18next.t('cancel')}
      </Button>
      <Button
        onClick={saveChanges}
        type="submit"
        size="small"
        disabled={disabled}
        busy={isSaving}
        destructive={!!destructive}
      >
        {changeButtonName}
      </Button>
    </DialogActions>
  );
};
